import { BaseError } from './base';

export class ClientNotFoundError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'client_not_found_error',
      docsUrl: null,
      name: 'ClientNotFoundError',
      shortMessage:
        'No Dynamic client has been created yet. Make sure you have called createDynamicClient() first.',
    });
  }
}
